import { defineStore } from 'pinia';

export default defineStore('bookingFlow', {
	state: () => ({
		treatmentDays: 0,
		price: null,
		isLoading: false,
	}),
});
